import { memo, useState, useEffect, useRef } from 'react';
import DpSearchLayout from './index.layout';
import useDebounce from '../../utils/hooks/use-debounce';
import { searchDinnerParties } from '../../services/dp-users.service';
import { useDispatch } from 'react-redux';
import { setSearchValue } from '../../redux/slices/search';
import { useSelector } from 'react-redux';
import SignInModal from '../custom-modal/content/sign-in';
import CustomModal from '../custom-modal/index';
import { modals } from '../../constans/modals';
import { groupType } from '../../constans/groupTypeEnum';
import { decodingAddress } from '../../services/google-maps';
import { useRouter } from 'next/router';
import { churchSearchByDomain, getGroupTypeVerboseNames } from '../../services/church.service';
import { churchSelect } from '../../redux/slices/church';

const DpSearch = () => {
  const router = useRouter();
  const didMount = useRef(false);
  const [dpSearchResult, setDpSearchResult] = useState([]);
  const [requestText, setRequestText] = useState('');
  const [isModalType, setIsModalType] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentType, setCurrentType] = useState(groupType.ALL.enum);
  const [groupNames, setGroupNames] = useState();
  const [textRequest, setTextRequest] = useState({
    title: '',
    type: '',
    longitude: '',
    latitude: '',
  });
  const debouncedSearchTerm = useDebounce(requestText, 500);

  const dispatch = useDispatch();
  const requestTextValue = useSelector(
    (state) => state.searchInput?.searchValue
  );

  useEffect(() => {

    const searchOnFirstRender = () => {
      if (requestTextValue) {
        setRequestText(requestTextValue);
      }
      const initialSearch = textRequest;
      if (router.query.filter) {
        const filterType = parseInt(router.query.filter);
        currentTypeHandler(filterType);
        initialSearch.type = filterType > 0 ? filterType : '';
      }
      const churchID = localStorage.getItem('newChurchId');
      const church = localStorage.getItem('current_church');
      if (church && church !== 'null' && church !== 'undefined')
        searchDinnerParties(initialSearch, churchID)
          .then((response) => {
            setDpSearchResult(response.data.data);
          })
          .catch((err) => console.log(err));
    }

    const church = localStorage.getItem('current_church');
    if (router.isReady) {
      if (router.query.slug) {
        churchSearchByDomain(router.query.slug)
        .then((res) => {
          if (res.data.data.length > 0) {
            selectChurch({...res.data.data[0]});
            getGroupTypeVerboseNames().then(({ data }) => {
              setGroupNames(data.data);
            });
            searchOnFirstRender();
          } else {
            router.push('/signin');
          }
        })
        .catch(err => console.log(err));
      } else if (!church || church === null || church === undefined) {
        localStorage.removeItem('current_church');
        localStorage.removeItem('newChurchId');
        router.push('/signin');
      } else if (church) {
        getGroupTypeVerboseNames().then(({ data }) => {
          setGroupNames(data.data);
        });
        searchOnFirstRender();
      }
    }
  }, [router.isReady, router.query.slug]);

  const selectChurch = (data) => {
    dispatch(churchSelect(data));
    localStorage.setItem('current_church', JSON.stringify(data));
    localStorage.setItem('newChurchId', data.id);
  };

  const currentTypeHandler = (newType) => {
    setCurrentType(newType);
    setTextRequest({ ...textRequest, type: newType > 0 ? newType : '' });
  };

  const handleInput = ({ target }) => setRequestText(target.value);

  const clearInput = () => {
    setRequestText('');
    setDpSearchResult([]);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  const handleModalOpen = (type) => {
    setIsModalType(type);
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (didMount.current) {
      if (requestText.length === 0) setDpSearchResult([]);
      setTextRequest({
        ...textRequest,
        title: requestText,
        longitude: '',
        latitude: '',
      });
    } else didMount.current = true;
  }, [requestText, didMount]);

  useEffect(() => {
    const churchID = localStorage.getItem('newChurchId');
    dispatch(setSearchValue(debouncedSearchTerm));
    if (debouncedSearchTerm !== '' && !isNaN(debouncedSearchTerm)) {
      decodingAddress(debouncedSearchTerm).then((response) => {
        if (response.results.length > 0) {
          const location = response.results[0].geometry.location;
          searchDinnerParties(
            {
              ...textRequest,
              title: '',
              longitude: location.lng,
              latitude: location.lat,
            },
            churchID
          )
            .then((response) => {
              setDpSearchResult(response.data.data);
            })
            .catch((err) => console.log(err));
        }
      });
    } else if (debouncedSearchTerm || currentType >= 0) {
      const church = localStorage.getItem('current_church');
      if (church && church !== 'null' && church !== 'undefined')
        searchDinnerParties(textRequest, churchID)
          .then((response) => {
            setDpSearchResult(response.data.data);
          })
          .catch((err) => console.log(err));
    } else setDpSearchResult([]);
  }, [debouncedSearchTerm, currentType]);

  return (
    <>
      <DpSearchLayout
        dpSearchResult={dpSearchResult}
        requestText={requestText}
        handleInput={handleInput}
        clearInput={clearInput}
        handleModalOpen={handleModalOpen}
        currentType={currentType}
        currentTypeHandler={currentTypeHandler}
        groupNames={groupNames}
      />
      <CustomModal
        isModalOpen={isModalOpen}
        handleModalClose={handleModalClose}
      >
        {isModalType.type === modals.SIGN_IN_USER && (
          <SignInModal handleModalClose={handleModalClose} />
        )}
      </CustomModal>
    </>
  );
};

export default memo(DpSearch);
